<frontend-pull-refresh></frontend-pull-refresh>

<section class="px-3 pb-3">
  <h1 class="pt-3 mb-3">Alerts Settings</h1>
  <form [formGroup]="alertsSettingsForm" (ngSubmit)="submit()">
    <div class="row form-group">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="settings-sms-play-audio" class="col-form-label lead">Play a sound when a new inbound message arrives</label>
      </div>
      <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 d-flex flex-column align-items-left">
        <div class="my-2">
          <label class="form-check-label">
            <input type="checkbox"
                   class="form-check-input"
                   name="arrivesSmsPlayAudio"
                   id="settings-sms-play-audio"
                   formControlName="arrivesSmsPlayAudio">Enabled
          </label>
        </div>
      </div>
    </div>
    <div class="row form-group">
      <div class="col-sm-5 col-md-5 col-lg-5 col-xl-4">
        <label for="settings-new-check-in" class="col-form-label lead">Play a sound when a new public check-in is made</label>
        <p></p>
      </div>
      <div class="col-sm-7 col-md-7 col-lg-7 col-xl-5 d-flex flex-column align-items-left">
        <div class="my-2">
          <label class="form-check-label">
            <input type="checkbox"
                   class="form-check-input"
                   name="newPublicCheckInPlayAudio"
                   id="settings-new-check-in"
                   formControlName="newPublicCheckInPlayAudio">Enabled
          </label>
        </div>
      </div>
    </div>
    <div class="row form-group">
      <div class="col-sm-3 offset-sm-3 offset-md-2">
        <button class="btn btn-info"
                type="submit"
                angularticsCategory="settings"
                angulartics2On="click"
                angularticsAction="Save Alerts Settings"
                [disabled]="alertsSettingsForm.pristine || !alertsSettingsForm.valid">Save
        </button>
      </div>
    </div>
  </form>

</section>
